module.exports = [
  "backend.config",
  "DS",
  "apiCall",
  function(backend, DS, apiCall) {
    var bundleNames = {
      myprofile: "profile",
      mybenefits: "benefits",
      news: "news",
      information: "information",
      approvals: "approvals",
      timesheets: "timesheets",
      leave: "leave",
      payroll: "payroll",
      health: "health",
      hrpolicies: "content",
      articleEditor: "articleEditor",
      forms: "forms",
      useradmin: "useradmin",
      orgsearch: "orgsearch",
      insights: "insights",
      ruletableadmin: "ruletableadmin",
      portaladmin: "portaladmin"
    };

    var systemconfig = DS.defineResource({
      name: "enterprisePlatformConfig",
      endpoint: "enterprisePlatformConfig",
      beforeInject: function(config, attrs) {
        attrs.appName = attrs.appName || window.orgConfig.appName || "Cue";

        attrs.appDetails.forEach(function(app) {
          app.bundleName = bundleNames[app.appId] || "";
          // app.enterpriseHasApp =
          //   app.enterpriseHasApp ||
          //   app.appId === "articleEditor" ||
          //   app.appId === "forms" ||
          //   app.appId === "users"; // TODO
        });

        attrs.appDetails.sort((a, b) => a.order - b.order);
      },
      afterFind: function(config, attrs, cb) {
        DS.defaults.afterFind(config, attrs, cb);

        var themeCss;
        if (attrs.appCustomCss) {
          themeCss = attrs.appCustomCss;
          appStorage.setItem("enterprise.theme", themeCss);
        } else {
          themeCss = "theme/theme." + GIT_VERSION + ".css";
          appStorage.removeItem("enterprise.theme");
        }
        var currentTheme = document.head.querySelector("link#theme");
        var newTheme =
          '<link id="theme" rel="stylesheet" type="text/css" href="' +
          themeCss +
          '">';

        if (!currentTheme || currentTheme.outerHTML !== newTheme) {
          document.head.insertAdjacentHTML("beforeend", newTheme);
        }
      }
    });

    return {
      $resource: systemconfig,
      getConfig: function() {
        var enterpriseCode = backend.enterprise
          ? backend.enterprise.code
          : "mobistream";
        return systemconfig.find(enterpriseCode, {
          attrs: {
            id: enterpriseCode
          }
        });
        /* .then(function(result) {
        console.warn('config api result', result);
        return apiCall({
          endpoint: '/enterprisePlatformConfig/menu//$/@/'
        }).then(function(res) {
          console.warn('menu api', res);
          const qwe = { ...result, menu: res };
          // result.menu = res;
          systemconfig.inject(qwe);
          console.log('WITHMENU', qwe);
          return qwe;
        });
      }) */
      }
    };
  }
];



// WEBPACK FOOTER //
// ./src/api/js-data/api/config.js